import React, { Component } from "react"
import { Link } from "react-router-dom"
import { t } from "../../i18next"
import MapIcon from "../../images/icons/map-108.png"
import { CurrentUser } from "../auth"
import { UnsentCasesNavigator } from "../damage-case"

export default class AppHeader extends Component {
  static propTypes = {}

  render() {
    return (
      <header className="common-app-header">
        <Link to="/" className="go-home" title={t("common.goHome")}>
          <img className="icon icon-map" alt="" src={MapIcon} />
        </Link>
        <div className="spacer" />
        <UnsentCasesNavigator className="go-cases" />
        <CurrentUser className="user-menu" />
      </header>
    )
  }
}



// WEBPACK FOOTER //
// ./src/features/common/AppHeader.js